export const SECTIONS = {
  MAP: 'Home Hero',
  ABOUT: 'Home About',
  INTRODUCTION: 'Home Description',
  SECTIONS: 'Home Sections',
  PARTNERS: 'Home Logos',
  APPENDIX_SECTIONS: 'Appendix Sections'
};

export const SECTIONS_LIST = Object.values(SECTIONS);

export const PARTNERS = 'partners';

export const CHART_SIZE = '100%';

export const RADIAL_CONFIG = {
  legendVisibility: false,
  titlesVisibility: false,
};

export const SCROLL_DURATION = 600;

export const SECTION_TITLE_MARGIN = '15%';
export const SECTION_MARGIN = 6;

export const JUMPER_TYPES = {
  SECTIONS: 'section',
  INTRODUCTION: 'introduction',
};

export const SECTION_ITEM_DEFAULT_WIDTH = 315;
export const SECTION_ITEM_MARGINS = 100;

export const MAP_HEIGHTS = {
  bigMobile: 290,
  mobile: 200,
};
